/** Normalize opaque Maloum cursors, preserving numeric zero and stopping cycles. */
export function nextVaultPage(page: {next: string | number | null}, _pages: unknown[], _last: string | undefined, params: (string | undefined)[]): string | undefined {
  if (page.next === null || page.next === undefined) return undefined;
  const next = String(page.next);
  return next && !params.includes(next) ? next : undefined;
}
export function uniqueVaultItems<T>(items: T[], key: (item: T) => string): T[] {
  const seen = new Set<string>();
  return items.filter(item => {const id=key(item);if(seen.has(id))return false;seen.add(id);return true;});
}
